import {getAppLang, getProperty, getUserToken, isDefined} from "../../../../utils";
import axios from "axios";
import {OPEN_AI} from "../../../../constants/api.constants";
import { openAIConstants } from "../../../../constants/General/openAI.constants";

export function openAI (params) {

    const requestOptions = {
        headers: { 'Content-Type': 'application/json',  'authToken': getUserToken(), 'language' : getAppLang()},
        body: {
            params: {
                property_id : getProperty(),
            }
        }
    };

    requestOptions.body.params = {
        property_id : getProperty(),
        query: {
                model: "gpt-4.1-mini",
                response_format: {
                    "type": "json_object"
                },
                messages: params.message
            },
    }

    return dispatch => {
        dispatch({
            type: 'OPEN_AI_LIST',
            payload: axios.post(OPEN_AI, requestOptions.body,{headers: requestOptions.headers})
                .then(response => response.data.data)
        })
    }
}

export function clearOpenAI() {
    return dispatch => {
        dispatch({
            type: openAIConstants.OPEN_AI_CLEAR,
        })
    }
}